import { Phone, ArrowRight } from "lucide-react";
import { BUSINESS } from "#/lib/constants";

/**
 * MobileActionBar — the persistent bottom conversion bar on small screens.
 *
 * Replaces the old single floating "Call" pill. A contractor site has two
 * conversion paths, not one: people who want to talk to someone now, and
 * people who want to send project details and be quoted. Burying either behind
 * a scroll costs jobs, so both live here permanently.
 *
 * Notes on the mobile specifics:
 * - Edge to edge and square, matching the site's rectangular language. The old
 *   pill was the only rounded-full element on the whole site.
 * - Sits above the iOS home indicator via --safe-bottom, which only resolves
 *   because __root.tsx sets viewport-fit=cover.
 * - Both halves are 56px tall, comfortably over the 44px minimum, and are split
 *   by a hairline so neither is mistaken for the other in a hurry.
 * - touch-action: manipulation removes the 300ms double-tap delay.
 * - Hidden at lg, where the header CTA and full nav are always visible.
 */
export function MobileActionBar() {
  return (
    <div
      className="fixed inset-x-0 bottom-0 z-40 border-t border-white/15 bg-graphite pb-[var(--safe-bottom)] lg:hidden"
      style={{ touchAction: "manipulation" }}
    >
      <div className="grid grid-cols-2">
        <a
          href={BUSINESS.phoneHref}
          aria-label={`Call ${BUSINESS.name} at ${BUSINESS.phone}`}
          className="flex min-h-14 items-center justify-center gap-2.5 border-r border-white/15 px-4 text-sm font-bold uppercase tracking-wide text-white no-underline transition-colors active:bg-white/10"
        >
          <Phone className="h-[18px] w-[18px] shrink-0 text-flame" aria-hidden="true" />
          Call Now
        </a>
        <a
          href="/quote"
          aria-label="Get a free concrete estimate"
          className="flex min-h-14 items-center justify-center gap-2.5 bg-flame px-4 text-sm font-bold uppercase tracking-wide text-white no-underline transition-colors active:bg-flame-dark"
        >
          Free Quote
          <ArrowRight className="h-[18px] w-[18px] shrink-0" aria-hidden="true" />
        </a>
      </div>
    </div>
  );
}
